import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon, SelectMenu } from '@livable/saas-react-components';
import { TextField, MenuItem } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import { FEE_TYPES_NAME, FEE_TYPES, PAYMENT_METHOD_TYPE, TRANSACTION_TYPES } from 'src/constants/payments';
import useStyles from './styles';
export default function SearchBar(_ref) {
  let externalSearchValue = _ref.externalSearchValue,
    externalTransactionType = _ref.externalTransactionType,
    externalTransactionSubType = _ref.externalTransactionSubType,
    externalStartDateRange = _ref.externalStartDateRange,
    externalStartDateRangeInit = _ref.externalStartDateRangeInit,
    externalEndDateRange = _ref.externalEndDateRange,
    externalEndDateRangeInit = _ref.externalEndDateRangeInit,
    externalUtilityTypesInfo = _ref.externalUtilityTypesInfo,
    transactionTypes = _ref.transactionTypes;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(moment(externalStartDateRangeInit).startOf('month').subtract(12, 'month').toDate()),
    _useState2 = _slicedToArray(_useState, 2),
    fromDate = _useState2[0],
    setFromDate = _useState2[1];
  const _useState3 = useState(moment(externalEndDateRangeInit).endOf('month').toDate()),
    _useState4 = _slicedToArray(_useState3, 2),
    toDate = _useState4[0],
    setToDate = _useState4[1];
  const _useState5 = useState('all'),
    _useState6 = _slicedToArray(_useState5, 2),
    subType = _useState6[0],
    setSubType = _useState6[1];
  const handleSubTypeChange = event => {
    setSubType(event.target.value);
    externalTransactionSubType(event.target.value);
  };
  const _useState7 = useState('all'),
    _useState8 = _slicedToArray(_useState7, 2),
    transactionType = _useState8[0],
    setTransactionType = _useState8[1];
  const handleTransactionChange = event => {
    setTransactionType(event.target.value);
    externalTransactionType(event.target.value);
    setSubType('all');
    externalTransactionSubType('all');
  };
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    searchKey = _useState0[0],
    setSearchKey = _useState0[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSearchKeyChange = e => {
    setSearchKey(e.target.value);
    externalSearchValue(e.target.value);
  };
  const handleDateChange = d => {
    if (d.startDate && d.endDate) {
      setFromDate(moment(d.startDate).startOf('day'));
      setToDate(moment(d.endDate).endOf('day'));
    }
  };
  const renderSwitch = transactionSwitchType => {
    switch (transactionSwitchType) {
      case TRANSACTION_TYPES.CapCredit:
      case TRANSACTION_TYPES.UtilityCharge:
        return externalUtilityTypesInfo.map(u => {
          return /*#__PURE__*/React.createElement(MenuItem, {
            value: u.utilityTypeName
          }, transactionSwitchType === TRANSACTION_TYPES.CapCredit ? 'CAP ' : '', u.utilityTypeName);
        });
      case TRANSACTION_TYPES.Fee:
        return Object.entries(FEE_TYPES).filter(_ref2 => {
          let _ref3 = _slicedToArray(_ref2, 2),
            value = _ref3[1];
          return [FEE_TYPES.LateFee,
          // FEE_TYPES.InsufficientFundsFee,
          FEE_TYPES.ConvenienceFee, FEE_TYPES.AdminFee, FEE_TYPES.PaperStatementFee].includes(value);
        }) // Note: filtered to show only allowed types
        .map(_ref4 => {
          let _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];
          return /*#__PURE__*/React.createElement(MenuItem, {
            value: key
          }, FEE_TYPES_NAME[value]);
        });
      case TRANSACTION_TYPES.Payment:
        return Object.entries(PAYMENT_METHOD_TYPE).map(_ref6 => {
          let _ref7 = _slicedToArray(_ref6, 2),
            key = _ref7[0],
            value = _ref7[1];
          return /*#__PURE__*/React.createElement(MenuItem, {
            value: key
          }, value);
        });
    }
  };
  useEffect(() => {
    // initial data set
    externalTransactionType(transactionType);
    externalTransactionSubType(subType);
    externalStartDateRange(fromDate);
    externalEndDateRange(toDate);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "charges-search",
    label: t('general.search'),
    variant: "outlined",
    value: searchKey,
    onChange: handleSearchKeyChange,
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.filterSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "who-selector",
    value: transactionType,
    label: t('general.transaction'),
    labelId: "who-selector-label",
    onChange: handleTransactionChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, t('general.all_transactions')), Object.entries(TRANSACTION_TYPES).filter(type => type !== 'Late Fee').map(_ref8 => {
    let _ref9 = _slicedToArray(_ref8, 2),
      key = _ref9[0],
      value = _ref9[1];
    return value !== 'Late Fee' && transactionTypes[key] ? /*#__PURE__*/React.createElement(MenuItem, {
      key: key,
      value: value
    }, value) : null;
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.filterSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "changes-type-selector",
    value: subType,
    label: t('general.subtypes'),
    labelId: "changes-type-selector-label",
    onChange: handleSubTypeChange,
    disabled: transactionType === 'all' || transactionType === TRANSACTION_TYPES.Credit || transactionType === TRANSACTION_TYPES.CustomCredit || transactionType === TRANSACTION_TYPES.CustomCharge || transactionType === TRANSACTION_TYPES.Refund || transactionType === TRANSACTION_TYPES.StatementCapCredit || transactionType === TRANSACTION_TYPES.Void
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, t('general.all_types')), renderSwitch(transactionType))), /*#__PURE__*/React.createElement("div", {
    className: classes.chargesRangeDatePicker
  }, /*#__PURE__*/React.createElement(RangeDatePicker, {
    fromDate: fromDate,
    toDate: toDate,
    format: 'MMMM yyyy',
    handleDateChange: d => handleDateChange(d)
  })));
}